import React, { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { Review } from '../../components'
import { reviewData } from '../../dummyData'
import Banner from './Banner'
import ConsultingSection from './ConsultingSection'
import EngagementSection from './EngagementSection'
import IndustriesSection from './IndustriesSection'
import PortfolioSection from './PortfolioSection'
import Statistics from './Statistics'

const Home = ({ darkToggle }) => {

  const location = useLocation()

  useEffect(() => {

    if (location.hash) {
      let x = location.hash.split('#')[1]
      const releventDiv = document.getElementById(x);
      releventDiv.scrollIntoView({ behavior: "smooth" });
    }

  }, [location]);

  return (
    <div>
      <Banner darkToggle={darkToggle} />
      <ConsultingSection darkToggle={darkToggle} />
      <div className=' dark:bg-slate-800 transition-all duration-700 '>
        <IndustriesSection />
      </div>
      <div id='review' className='bg-gray-50 dark:bg-gray-900 transition-all duration-700'>
        <Review data={reviewData} darkToggle={darkToggle} />
      </div>
      <div className='dark:bg-slate-800 transition-all duration-700'>
        <EngagementSection />
      </div>
      <div className='bg-gray-50 dark:bg-gray-900 transition-all duration-700'>
        <PortfolioSection darkToggle={darkToggle} />
      </div>
      <div className='dark:bg-slate-800 transition-all duration-700'>
        <Statistics />
      </div>

    </div>
  )
}

export default Home

